
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "Perfil",
    dangerZone: "Zona de Peligro",
    deleteAccount: "Eliminar Cuenta",
    confirmDelete: "Confirmar Eliminación",
    deleteWarning: "Esta acción no se puede deshacer",
    confirmDeleteButton: "Sí, eliminar mi cuenta",
    accountDeleted: "Cuenta Eliminada",
    accountDeletedMessage: "Su cuenta ha sido eliminada exitosamente"
  },
  common: {
    cancel: "Cancelar",
    delete: "Eliminar",
    deleteConfirmation: "Confirmar Eliminación",
    deleteConfirmationMessage: "¿Estás seguro de que quieres eliminar"
  }
};
